$(document).ready(function () {
  if($('.mouse').length > 0) {
    $(window).scroll(function() {
      scrollPercent = 100 * $(window).scrollTop() / $(window).height();
      scrollTranslateTitle = 200 * scrollPercent / 100;
      scrollOpacity = 1 - 4*(scrollPercent / 100);
      $('.mouse').css('transform', 'translateY( -' + 0.7*scrollTranslateTitle + 'px)');
      $('.mouse').css('opacity', scrollOpacity);
      $('.mouse_ball').css('transform', 'translate3d(-50%, ' + 8*scrollPercent + '%, 0)' );
    });
  }
});